/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSeoLinks_item = {
    readonly internalBuyLinks: ReadonlyArray<{
        readonly anchorText: string | null;
        readonly url: string | null;
    } | null> | null;
    readonly " $refType": "PdpRespSeoLinks_item";
};
export type PdpRespSeoLinks_item$data = PdpRespSeoLinks_item;
export type PdpRespSeoLinks_item$key = {
    readonly " $data"?: PdpRespSeoLinks_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSeoLinks_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSeoLinks_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "internalBuyLinks",
      "storageKey": null,
      "args": null,
      "concreteType": "InternalBuyLinkType",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "anchorText",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "url",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '4b68a57e8adb3294f15b813bd8a82c3a';
export default node;
